import { ComplexValue } from 'app/types-shared';
import { ValidationProps } from 'ui/common/validation/types';

export enum SecondaryTextMode {
  disabled,
  readOnly,
  normal,
  required
}

export interface MainLanguageProps {
  primaryText: string;
  secondaryText: string;
  primaryTextMaxLength: number;
  secondaryTextMaxLength: number;
  mainLanguage: number;
  mainLanguageDescription: string;
  secondaryTextMode: SecondaryTextMode;
  readOnly: boolean;
  displayCopyToAll: boolean;
  onPrimaryTextChange: (languageId: number, text: string) => void;
  onSecondaryTextChange: (languageId: number, text: string) => void;
  copyPrimaryTextToAllTranslations: () => void;
  copySecondaryTextToAllTranslations: () => void;
  primaryTextValidation: ValidationProps;
  secondaryTextValidation: ValidationProps;
  primaryTextLabel: string;
  secondaryTextLabel: string;
  secondaryTextInfo?: string;
  copyPrimaryTextToAllLabel: string;
  copySecondaryTextToAllLabel: string;
}

export interface TranslationRowProps {
  language: ComplexValue<number>;
  primaryText: string;
  secondaryText: string;
  primaryTextMaxLength: number;
  secondaryTextMaxLength: number;
  secondaryTextMode: SecondaryTextMode;
  readOnly: boolean;
  onPrimaryTextChange: (languageId: number, text: string) => void;
  onSecondaryTextChange: (languageId: number, text: string) => void;
  primaryTextValidation: ValidationProps;
  secondaryTextValidation: ValidationProps;
  primaryTextLabel: string;
  secondaryTextLabel: string;
  secondaryTextInfo?: string;
}

export type LanguageNameProps = {
  text: string;
  className: string;
};

export interface TranslationsProps {
  primaryText: ComplexValue<number>[];
  secondaryText: ComplexValue<number>[];
  primaryTextValueKey: string;
  secondaryTextValueKey: string;
  primaryTextMaxLength: number;
  secondaryTextMaxLength: number;
  languageOptions: ComplexValue<number>[];
  mainLanguage: number;
  mainLanguageDescription?: string;
  secondaryTextMode: SecondaryTextMode;
  readOnly: boolean;
  onPrimaryTextChange: (languageId: number, text: string) => void;
  onSecondaryTextChange: (languageId: number, text: string) => void;
  copyPrimaryTextToAllTranslations: () => void;
  copySecondaryTextToAllTranslations: () => void;
  hasTranslationsToggled: boolean;
  switchTranslationsToggle: (toggled?: boolean) => void;
  validation: ValidationProps;
  validationLongDescription?: ValidationProps;
  primaryTextLabel: string;
  secondaryTextLabel: string;
  secondaryTextInfo?: string;
  copyPrimaryTextToAllLabel: string;
  copySecondaryTextToAllLabel: string;
  translationsHeaderLabel: string;
  switchTranslationsToggleLabel: string;
}

export type TranslationsToggleProps = {
  isToggled: boolean;
  switchTranslationsToggleLabel: string;
  onChange: (value: boolean) => void;
};
